/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import './Dependents.css';
import { Grid, Box, Typography } from '@mui/material';
import { fonts, themes } from '../../../common/themes/themes';
import DependentsTile from '../../../common/components/DependentsTile/DependentsTile';
import _ from 'lodash';
import DepDocumentsController from '../../../common/Modals/Dependents/DependentsDocuments/DepDocumentsController';
import emptyIcon from '../../../assets/images/empty_icon.svg';
import DepInsuranceController from '../../../common/Modals/Dependents/DependentsInsurance/DepInsuranceController';
import default_avatar from '../../../assets/images/default_avatar.png';
import { useAppSelector } from '../../../infra/hooks';
import Loader from '../../../common/Lottifiers/Loader/Loader';
import { DateField } from '../../../components';
import { baseDateFormatting } from '../../../common/helper';

interface propsType {
  allDependentList: any;
  isLoading?: boolean;
  trans?: any;
  i18n?: any;
}
const DependentsPresenter: React.FC<propsType> = ({
  allDependentList,
  isLoading,
  trans,
  i18n,
}) => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);

  const [documentsListModal, showDocumentsList] = useState(false);
  const [depdDocumentsList, setDepdDocumentsList] = useState([]);
  const [insuranceListModal, showInsuranceListModal] = useState(false);
  const [insuranceList, setInsuranceList] = useState([]);

  const handleDependentsDocsList = (Dep: any) => {
    setDepdDocumentsList(Dep);
    showDocumentsList(true);
  };

  const handleInsuranceList = (Dep: any) => {
    setInsuranceList(Dep);
    showInsuranceListModal(true);
  };

  return (
    <div>
      <Grid
        container
        style={{
          display: 'flex',
          flexWrap: 'nowrap',
          marginTop: isHRView ? '' : '4em',
          width: '100vw',
          paddingRight: '8em',
        }}
      >
        <Grid
          item
          xs={11}
          sm={11}
          md={11}
          lg={11}
          sx={{
            backgroundColor: '#F5F5FD',
            width: '100%',
            padding: '1.75em',
            marginLeft:
              isHRView && i18n.language == 'en'
                ? '11em'
                : !isHRView && i18n.language == 'en'
                  ? '14em'
                  : '',
            marginRight: i18n.language == 'ar' ? '15em' : '',
          }}
        >
          <Grid
            container
            spacing={1}
            style={{
              paddingLeft: isHRView ? '2em' : '',
            }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{
                width: '100%',
              }}
            >
              <Grid
                container
                style={{
                  width: 'auto',
                  background: '#FFFFFF 0% 0% no-repeat padding-box',
                  borderRadius: '10px',
                  opacity: '1',
                  display: 'flex',
                  flexDirection: 'row',
                  paddingTop: '1em',
                  paddingBottom: '1em',
                  paddingLeft: '1em',
                  paddingRight: '1em',
                }}
              >
                <Grid item xs={9}>
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.header,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Dependents')}
                  </Typography>
                </Grid>
              </Grid>
              {isLoading ? (
                <Loader height={300} width={400} />
              ) : (
                <>
                  <Grid
                    container
                    spacing={3}
                    style={{ width: '100%', marginBottom: '13em' }}
                  >
                    <Grid item xs={12}></Grid>
                    {allDependentList.length > 0 ? (
                      _.map(allDependentList, (Dep: any) => {
                        return (
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <DependentsTile
                              Dep_id={Dep?.id}
                              profilePic={
                                Dep?.photo ? Dep?.photo : default_avatar
                              }
                              title1={
                                Dep
                                  ? Dep?.first_name + ' ' + Dep?.last_name
                                  : '--'
                              }
                              relation={
                                Dep?.relationship_type
                                  ? Dep?.relationship_type?.name
                                  : '--'
                              }
                              tile_key1={trans('Country of Birth')}
                              tile_value1={Dep ? Dep?.country?.name : '--'}
                              tile_key2={trans('Date of Birth')}
                              tile_value2={
                                Dep ? (
                                  <DateField
                                    value={Dep?.dob}
                                    format={baseDateFormatting}
                                  />
                                ) : (
                                  '--'
                                )
                              }
                              tile_key3={trans('Ticket')}
                              tile_value3={
                                Dep ? trans(Dep?.ticket_entitlement) : '--'
                              }
                              tile_key4={trans('Ticket Frequency')}
                              tile_value4={
                                Dep?.frequency ? Dep?.frequency?.name : '--'
                              }
                              tile_key5={`${trans('Documents')} ( ${
                                Dep
                                  ? Dep?.active_dependent_documents?.length
                                  : '--'
                              } )`}
                              tile_key6={`${trans('Insurance')} ( ${
                                Dep
                                  ? Dep?.active_dependent_insurances?.length
                                  : '--'
                              } )`}
                              onClick1={() => handleDependentsDocsList(Dep)}
                              onClick2={() => handleInsuranceList(Dep)}
                            />
                          </Grid>
                        );
                      })
                    ) : (
                      // <Grid container style={{ backgroundColor: "white" }}>
                      <>
                        <Grid container style={{ marginTop: '2em' }}>
                          <Grid
                            item
                            xs={12}
                            style={{
                              alignItems: 'center',
                              justifyContent: 'center',
                              display: 'flex',
                            }}
                          >
                            <Box
                              style={{
                                borderRadius: '12px',
                                width: '70%',
                                height: '310px',

                                textAlign: 'center',
                                backgroundColor: 'white',
                              }}
                            >
                              <Box style={{ marginTop: '3em' }} />
                              <img src={emptyIcon} />
                              <Grid
                                item
                                xs={12}
                                style={{
                                  textAlign: 'center',
                                }}
                              >
                                <Typography
                                  style={{
                                    fontFamily: fonts.fontFamily,
                                    fontSize: fonts.title,
                                    color: themes.blackDefault,
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {trans('Not Added')}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                style={{
                                  textAlign: 'center',
                                }}
                              >
                                <Typography
                                  style={{
                                    fontFamily: fonts.fontFamily,
                                    fontSize: fonts.subtitle,
                                    color: themes.defaultIcon,
                                  }}
                                >
                                  {trans(
                                    'Currently you haven’t any Dependents',
                                  )}
                                </Typography>
                              </Grid>
                            </Box>
                          </Grid>
                        </Grid>

                        {/* </Grid> */}
                      </>
                    )}
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {documentsListModal && (
        <DepDocumentsController
          isModalOpen={documentsListModal}
          depdDocumentsList={depdDocumentsList}
          closeModal={() => showDocumentsList(false)}
          trans={trans}
        />
      )}
      {insuranceListModal && (
        <DepInsuranceController
          isModalOpen={documentsListModal}
          insuranceList={insuranceList}
          closeModal={() => showInsuranceListModal(false)}
          trans={trans}
        />
      )}
    </div>
  );
};
export default DependentsPresenter;
